var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C7.83152 0 8.14946 0.131696 8.38388 0.366117C8.61831 0.600537 8.75 0.918479 8.75 1.25V6.25H13.75C14.0815 6.25 14.3995 6.3817 14.6339 6.61612C14.8683 6.85054 15 7.16848 15 7.5C15 7.83152 14.8683 8.14946 14.6339 8.38388C14.3995 8.6183 14.0815 8.75 13.75 8.75H8.75V13.75C8.75 14.0815 8.61831 14.3995 8.38388 14.6339C8.14946 14.8683 7.83152 15 7.5 15C7.16848 15 6.85054 14.8683 6.61612 14.6339C6.3817 14.3995 6.25 14.0815 6.25 13.75V8.75H1.25C0.91848 8.75 0.600536 8.6183 0.366117 8.38388C0.131696 8.14946 0 7.83152 0 7.5C0 7.16848 0.131696 6.85054 0.366117 6.61612C0.600536 6.3817 0.91848 6.25 1.25 6.25H6.25V1.25C6.25 0.918479 6.3817 0.600537 6.61612 0.366117C6.85054 0.131696 7.16848 0 7.5 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.44c05b454c6043004b0363019b59abe2.svg";
export { ForwardRef as ReactComponent };